import React from 'react'
import cctv from '../assets/cctv.jpg';
import { TbDeviceCctv } from "react-icons/tb";
import { MdOutlineHighQuality } from "react-icons/md";
import { MdOutlineSwitchAccessShortcut } from "react-icons/md";
import { MdOutlineSettingsSuggest } from "react-icons/md";
import  ott  from '../assets/OTT.jpg';
import { motion } from "framer-motion";
const Services = () => {
  return (
    <div name="services" className="my-10 scroll-mt-20">
        <motion.h2 className="text-4xl m-2 text-center text-blue-950 font-semibold font-poppins" initial={{y:50, opacity: 0}} whileInView={{y: 0, opacity: 1}} transition={{duration: 1, ease: "easeIn"}}>Additional Services</motion.h2>
        <div className="m-2 md:m-4">
        <motion.p initial={{y:50, opacity: 0}} whileInView={{y: 0, opacity: 1}} transition={{duration: 1, ease: "easeIn"}} className="p-4 text-xl font-inter">Other than broadband connection, we also provide:</motion.p>
        <div className="grid grid-cols-1 md:grid-cols-2">
           <motion.div initial={{ y: 100, opacity: 0 }}
  whileInView={{ y: 0, opacity: 1 }} viewport={{ once: true, amount: 0.25}}
  transition={{ type: "spring", stiffness: 10 , damping: 3}} className="bg-gradient-to-r from-indigo-900 via-purple-800 to-indigo-900 rounded-lg m-2 md:m-4"> 
            <div className="p-3">
                <h2 className="text-gray-100 text-xl underline underline-offset-2 decoration-2 font-bold font-poppins">CCTV Installation</h2>
            </div>
            <div className="flex flex-col justify-between items-center ">
               <div className="mt-3 w-full h-64 md:h-[54vh]"> 
                <img src={cctv} alt="" className='object-cover w-full h-full'/>
               </div>
               <div className="flex flex-col items-start mt-4 mb-4 m-2">
                <p className="text-gray-100 text-xl font-roboto">Keep your home and business secure with SingTel’s professional CCTV installation.</p>
                <p className="text-gray-100 mt-3">We offer:</p>
                <div className="p-2">
                    <div className="flex items-start gap-1 text-gray-100">
                    <MdOutlineHighQuality className="text-yellow-300" size={23}/>  
                    <p>High-quality indoor and outdoor cameras</p>
                    </div>
                    <div className="flex items-start gap-1 text-gray-100">
                    <TbDeviceCctv className="text-yellow-300" size={23}/>  
                    <p>24/7 monitoring</p>
                    </div>
                    <div className="flex items-start gap-1 text-gray-100">
                    <MdOutlineSwitchAccessShortcut className="text-yellow-300" size={23}/>  
                    <p>Remote access</p>
                    </div>
                    <div className="flex items-start gap-1 text-gray-100">
                    <MdOutlineSettingsSuggest className="text-yellow-300" size={23}/>  
                    <p>Expert installation and support</p>
                    </div>
                    
                </div>
                <p className="text-white mt-3 text-md font-inter text-center">Protect what matters most - anytime, anywhere</p>
              </div>
 
            </div>
            
           </motion.div>
           <motion.div initial={{ y: -100, opacity: 0 }}
  whileInView={{ y: 0, opacity: 1 }} viewport={{ once: true, amount: 0.25}}
  transition={{ type: "spring", stiffness: 10 , damping: 3}} className="bg-gradient-to-r from-indigo-900 via-purple-800 to-indigo-900 rounded-lg m-2 md:m-4"> 
            <div className="p-3">
                <h2 className="text-gray-100 text-xl underline underline-offset-2 decoration-2 font-bold font-poppins">OTT Platform Subscription</h2>
            </div>
            <div className="flex flex-col justify-between items-center">
               <div className="mt-3  w-full h-64 md:h-[54vh] "> 
                <img src={ott} alt="" className='object-cover w-full h-full'/>
               </div>
               <div className="flex flex-col items-start mt-4 mb-4 m-2">
                <p className="text-gray-100 text-xl font-inter">Enjoy unlimited entertainment with SingTel’s OTT bundles.</p>
                <p className="text-gray-100 mt-3">We provide subscription for:</p>
                <div className="p-2 flex justify-evenly items-center flex-wrap gap-5 md:grid grid-cols-4">
                    <div className="bg-gray-800 p-2 text-gray-100 ">
                    <p>Netflix</p>
                    </div>
                    <div className="bg-gray-800 p-2 text-gray-100">
                    <p>Amazon Prime</p>
                    </div>
                    <div className="bg-gray-800 p-2 text-gray-100">
                    <p>Jio Hotstar</p>
                    </div>
                    <div className="bg-gray-800 p-2 text-gray-100">
                    <p>Sony Liv</p>
                    </div>
                    <div className="bg-gray-800 p-2 text-gray-100">
                    <p>ZEE 5</p>
                    </div>
                    <div className="bg-gray-800 p-2 text-gray-100">
                    <p>MX Player Gold</p>
                    </div>
                    <div className="bg-gray-800 p-2 text-gray-100">
                    <p>ALT Balaji</p>
                    </div>
                    <div className="bg-gray-800 p-2 text-gray-100">
                    <p>...</p>
                    </div>
                    
                </div>
              </div>
                <p className="text-white mt-3 text-md text-center font-inter">One Provider for all you favorite OTT platforms.</p>
            </div>
            
           </motion.div>

        </div>
        </div>
    </div>
  )
}

export default Services